import React from 'react'
// eslint-disable-next-line no-unused-vars
import { FormattedMessage } from 'react-intl'
import ProfileMenu from './ProfileMenu'
import ClinicSelector from './ClinicSelector'
import styles from './style.module.scss'

class TopBar extends React.Component {
  render() {
    return (
      <div className={styles.topbar}>
        <div className="mr-auto" />
        <div className="mr-4">
          <ClinicSelector />
        </div>
        <ProfileMenu />
      </div>
    )
  }
}

export default TopBar
